<div class="cashout-confirm-payment-container">
  <div class="cashout-confirm-payment-header">
    <img src="wealth-assets/icons/wallet-black.svg" />
    <div class="cashout-confirm-payment-header-title">بررسی اطلاعات برداشت</div>
  </div>
  <div class="cashout-confirm-payment-info">
    <div class="cashout-confirm-payment-info-items">
      <div class="cashout-confirm-payment-info-item">
        <span> برداشت از کیف پول ETF</span>
      </div>
      <div class="cashout-confirm-payment-info-item">
        <div>
          <span>انتقال به</span>
        </div>
        <div class="bank-info">
          <img src="wealth-assets/bank-icons/{{ bankName() }}.svg" />
          <span>{{ data.shabaNumber }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="cashout-confirm-payment-description">
    <div class="cashout-confirm-payment-description-title">
      <ngx-callout
        [mode]="'single-without-title'"
        [message]="'نکات مهم'"
      />
    </div>
    <div class="cashout-confirm-payment-description-text">
      <span>
        اگر تا ساعت ۱۴ روز کاری درخواست خود را ثبت کنید، مبلغ ثبت شده ۱ روز کاری بعد و درخواست پس از ساعت ۱۴ و یا در روز‌های تعطیل ۲ روز
        کاری بعد به حساب بانکی شما نزد کارگزاری واریز خواهد شد.
      </span>
    </div>
  </div>
</div>
<div class="w-100 d-flex cashout-confirm-payment-button">
  <div class="amount">
    <span class="bt-2"> مبلغ پرداختی </span>
    <span class="t-7 is-currency">{{ data.amount | number }} ریال</span>
  </div>
  <div class="button-container">
    <ngx-button
      [fullWidth]="true"
      mode="form"
      [size]="'medium'"
      (clickHandler)="close()"
      [style]="'tinted-on-elevated'"
    >
      ویرایش مبلغ
    </ngx-button>
    <ngx-button
      [style]="'fill'"
      [brandButton]="true"
      [fullWidth]="true"
      mode="form"
      [size]="'medium'"
      (clickHandler)="confirm()"
      [classNames]="['p-0']"
    >
      تایید و برداشت
    </ngx-button>
  </div>
</div>
